// extracted by mini-css-extract-plugin
export default {"box":"LinkedAccounts_box__0HCEp","row":"LinkedAccounts_row__rAb7Y"};